import {DxModalOptions} from "./ui-options/dx-modal-options";
import {ComponentFactory, Type} from "@angular/core";


/** Коньекст модального окна, передающийся в саму модалку через механизмы Semantic-UI. */
export class DxModalContext {
  /** Опции модального окна. */
  private readonly _options: DxModalOptions;
  /**
   * Возможность задать альтернативный заголовок модалки.
   * У этого поля приоритет относительно `title` из опций.
   */
  private _title: string;
  /** Сообщение в теле модалки. */
  private _message: string;
  /** Произвольный компонет для отображения в теле модального окна. */
  private _contentComponent: Type<any>;
  /** Фабрика для произволного компонента. Читай подробнее описание метода `DxModalService.showEditByFactory(...)`. */
  private _componentFactory: ComponentFactory<any>;
  /**
   *  Входные аргументы комонента, открываемого в контенте.
   *  Например это может быть: Map<string, any>. Но лучше использовать типизированные данные
   */
  private _inputs: any;


  constructor(options: DxModalOptions) {
    this._options = options;
  }


  get options(): DxModalOptions {
    return this._options;
  }

  get title(): string {
    return this._title;
  }

  set title(value: string) {
    this._title = value;
  }

  get message(): string {
    return this._message;
  }

  set message(value: string) {
    this._message = value;
  }

  get contentComponent(): Type<any> {
    return this._contentComponent;
  }

  set contentComponent(value: Type<any>) {
    this._contentComponent = value;
  }

  get inputs(): any {
    return this._inputs;
  }

  set inputs(value: any) {
    this._inputs = value;
  }

  get componentFactory(): ComponentFactory<any> {
    return this._componentFactory;
  }

  set componentFactory(value: ComponentFactory<any>) {
    this._componentFactory = value;
  }
}
